import { render, staticRenderFns } from "./file-drop-area.component.vue?vue&type=template&id=bf66da0e&scoped=true&"
import script from "./file-drop-area.component.ts?vue&type=script&lang=js&"
export * from "./file-drop-area.component.ts?vue&type=script&lang=js&"
import style0 from "./file-drop-area.component.css?vue&type=style&index=0&id=bf66da0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf66da0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
